/**
 * @class configMobile
 *
 * Manage our configuration settings for mobile styles.

 */

export default {
   // Application List
   appListRowHeight: 67,

   // button types
   buttonWidthLarge: 200,
   buttonWidthMedium: 150,
   buttonWidthSmall: 100,
   buttonWidthExtraSmall: 50,

   // tab types
   tabWidthLarge: 200,
   tabWidthMedium: 120,
   tabWidthSmall: 100,
   tabWidthExtraSmall: 50,

   // column types
   columnWidthLarge: 250,
   columnWidthMedium: 200,
   columnWidthSmall: 150,
   columnWidthExtraSmall: 100,

   // spacers
   xSmallSpacer: 1,
   smallSpacer: 1,
   mediumSpacer: 10,
   largeSpacer: 20,
   xLargeSpacer: 50,
   xxLargeSpacer: 100,
   xxxLargeSpacer: 120,
   appListSpacerRowHeight: 10,
   appListSpacerColMinWidth: 1,
   appListSpacerColMaxWidth: 1,
   objectWorkspaceColWidth: 1,

   // labels
   labelWidthSmall: 50,
   labelWidthMedium: 80,
   labelWidthLarge: 120,
   labelWidthXLarge: 120,
   labelWidthXXLarge: 120,
   labelWidthCheckbox: 0,

   // hide elements for mobile
   hideMobile: true,
};
